import { Box, Typography } from '@mui/material';
import { forwardRef } from 'react';
import { useAnalytics } from '../../hooks/useAnalytics';

/**
 * Partnership contact section with LinkedIn CTA (commented out form included)
 *
 * @param {Object} props Component props
 * @param {React.Ref} ref Ref for scrolling functionality
 * @returns {JSX.Element} Partnership contact section
 */
const PartnershipContactSection = forwardRef((_props, ref) => {
  const { trackCTA } = useAnalytics();

  const handleLinkedInClick = () => {
    trackCTA("Let's Discuss Partnership", 'PartnershipContactSection');
    // Let the default link behavior continue
  };

  return (
    <Box
      ref={ref}
      sx={{
        mt: 8,
        p: 6,
        backgroundColor:
          'color-mix(in srgb, var(--color-primary) 2%, transparent)',
        borderRadius: '12px',
        border:
          '2px solid color-mix(in srgb, var(--color-primary) 10%, transparent)',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontWeight: 600,
          mb: 2,
          color: 'var(--color-heading)',
          textAlign: 'center',
        }}
      >
        Partner with RSM Collective
      </Typography>
      <Typography
        sx={{
          color: 'var(--color-text-muted)',
          mb: 4,
          fontSize: '1.125rem',
          maxWidth: '800px',
          mx: 'auto',
          textAlign: 'center',
        }}
      >
        Tell us about your organization and how you'd like to collaborate.
      </Typography>

      {/* COMMENTED OUT - Original Partnership Form - Keep for future use
      <Box component="form" sx={{ maxWidth: '600px', mx: 'auto' }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography sx={{ mb: 1, fontWeight: 600, color: '#1A1A1A' }}>
                First Name *
              </Typography>
              <Box
                component="input"
                type="text"
                required
                sx={{
                  width: '100%',
                  p: 2,
                  border: '2px solid #e0e0e0',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  '&:focus': {
                    outline: 'none',
                    borderColor: 'var(--color-primary)',
                  },
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box>
              <Typography sx={{ mb: 1, fontWeight: 600, color: '#1A1A1A' }}>
                Last Name *
              </Typography>
              <Box
                component="input"
                type="text"
                required
                sx={{
                  width: '100%',
                  p: 2,
                  border: '2px solid #e0e0e0',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  '&:focus': {
                    outline: 'none',
                    borderColor: 'var(--color-primary)',
                  },
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box>
              <Typography sx={{ mb: 1, fontWeight: 600, color: '#1A1A1A' }}>
                Email *
              </Typography>
              <Box
                component="input"
                type="email"
                required
                sx={{
                  width: '100%',
                  p: 2,
                  border: '2px solid #e0e0e0',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  '&:focus': {
                    outline: 'none',
                    borderColor: 'var(--color-primary)',
                  },
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box>
              <Typography sx={{ mb: 1, fontWeight: 600, color: '#1A1A1A' }}>
                Organization
              </Typography>
              <Box
                component="input"
                type="text"
                sx={{
                  width: '100%',
                  p: 2,
                  border: '2px solid #e0e0e0',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  '&:focus': {
                    outline: 'none',
                    borderColor: 'var(--color-primary)',
                  },
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box>
              <Typography sx={{ mb: 1, fontWeight: 600, color: '#1A1A1A' }}>
                Partnership Interest
              </Typography>
              <Box
                component="select"
                sx={{
                  width: '100%',
                  p: 2,
                  border: '2px solid #e0e0e0',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  backgroundColor: 'white',
                  '&:focus': {
                    outline: 'none',
                    borderColor: 'var(--color-primary)',
                  },
                }}
              >
                <option value="">Select partnership type...</option>
                <option value="consultant">
                  Join as Technology Consultant
                </option>
                <option value="integrator">
                  Systems Integration Partnership
                </option>
                <option value="client">
                  Client/Customer Collaboration
                </option>
                <option value="vendor">
                  Technology Vendor Partnership
                </option>
                <option value="other">Other Partnership</option>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box>
              <Typography sx={{ mb: 1, fontWeight: 600, color: '#1A1A1A' }}>
                Tell us about your collaboration interests
              </Typography>
              <Box
                component="textarea"
                rows="4"
                sx={{
                  width: '100%',
                  p: 2,
                  border: '2px solid #e0e0e0',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  fontFamily: 'inherit',
                  resize: 'vertical',
                  '&:focus': {
                    outline: 'none',
                    borderColor: 'var(--color-primary)',
                  },
                }}
                placeholder="Describe your organization, relevant experience, and specific areas where you'd like to collaborate with RSM Collective..."
              />
            </Box>
          </Grid>

          <Grid item xs={12} sx={{ textAlign: 'center', mt: 2 }}>
            <Button
              type="submit"
              variant="contained"
              size="large"
              sx={{
                backgroundColor: 'var(--color-primary)',
                color: 'white',
                py: 2,
                px: 5,
                fontWeight: 600,
                textTransform: 'none',
                fontSize: '1.125rem',
                borderTopLeftRadius: 0,
                borderTopRightRadius: '16px',
                borderBottomLeftRadius: '16px',
                borderBottomRightRadius: 0,
                '&:hover': {
                  backgroundColor: '#658309',
                },
              }}
            >
              Submit Partnership Inquiry
            </Button>
          </Grid>
        </Grid>
      </Box>
      END COMMENTED OUT FORM */}

      {/* LinkedIn CTA for Partnership Inquiries */}
      <Box sx={{ maxWidth: '800px', mx: 'auto', textAlign: 'center' }}>
        <Box
          sx={{
            backgroundColor: 'var(--color-card)',
            p: 6,
            borderRadius: '16px',
            boxShadow: '0 12px 32px rgba(0,0,0,0.12)',
            border: '1px solid var(--color-border)',
            position: 'relative',
            // Green corners for partnership CTA
            '&::before': {
              content: '""',
              position: 'absolute',
              top: -1,
              left: -1,
              width: '60px',
              height: '60px',
              borderTop: '4px solid var(--color-primary)',
              borderLeft: '4px solid var(--color-primary)',
              borderRadius: 0,
            },
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: -1,
              right: -1,
              width: '60px',
              height: '60px',
              borderBottom: '4px solid var(--color-primary)',
              borderRight: '4px solid var(--color-primary)',
              borderRadius: 0,
            },
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              mb: 3,
              color: 'var(--color-heading)',
              fontSize: { xs: '1.75rem', md: '2.25rem' },
            }}
          >
            Ready to Partner with Us?
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: 'var(--color-text-muted)',
              mb: 4,
              lineHeight: 1.7,
              fontSize: '1.125rem',
              maxWidth: '600px',
              mx: 'auto',
            }}
          >
            Join forces with RSM Collective's expert network. Whether you're
            seeking consulting excellence, technology transformation, or
            strategic partnerships - let's create something extraordinary
            together.
          </Typography>

          <Typography
            component="a"
            href="https://www.linkedin.com/company/rsm-collective/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleLinkedInClick}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 2,
              backgroundColor: 'var(--color-primary)',
              color: 'var(--color-primary-text)',
              textDecoration: 'none',
              px: 4,
              py: 2.5,
              borderRadius: '12px',
              fontWeight: 700,
              fontSize: '1.25rem',
              transition: 'all 0.4s ease',
              boxShadow:
                '0 8px 24px color-mix(in srgb, var(--color-primary) 30%, transparent)',
              '&:hover': {
                backgroundColor: 'var(--color-primary-dark)',
                transform: 'translateY(-3px)',
                boxShadow:
                  '0 12px 36px color-mix(in srgb, var(--color-primary) 40%, transparent)',
              },
              '&:active': {
                transform: 'translateY(-1px)',
              },
            }}
          >
            <Box component="span" sx={{ fontSize: '1.5rem' }}>
              🚀
            </Box>
            Let's Discuss Partnership
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mt: 3,
              color: 'var(--color-text-muted)',
              fontStyle: 'italic',
              fontSize: '1rem',
            }}
          >
            Connect with us on LinkedIn to discuss how we can accelerate your
            success
          </Typography>
        </Box>
      </Box>
    </Box>
  );
});

PartnershipContactSection.displayName = 'PartnershipContactSection';

export default PartnershipContactSection;
